import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import Spinner from "../../assets/images/Spinner.gif";
import { getUserInsightsAction } from "../../Redux/Actions/UserInsights";
import { ApiUrl } from "../Common/ApiUrl";
import { Constants } from "../Common/Constants";
import PageHeader from "../Common/PageHeader";
import { RoutesUrl } from "../Common/RoutesUrl";
import Analytics from "./Analytics";
import { AvgWorkoutsCard } from "./AvgWorkoutsCard";
import CardBlock from "./CardBlock";

const UserDetail = () => {
  const { userSingle } = useSelector((store) => store.Users);
  const [loader, setLoader] = useState(false);
  const userProfile = useSelector((store) => store.UserProfileReducer.userProfile);
  const userInsights = useSelector((store) => store.UserInsights.userInsights);
  const location = useLocation();


  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(function () {
    dispatch(getUserInsightsAction(id));
  }, [id]);


  console.log(userInsights);


  const downloadCustomWorkout = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        // `${process.env.REACT_APP_API_URL}${ApiUrl.USER_CUSTOM_WORKOUT}?userId=${userSingle?.user?._id}`,
        `${process.env.REACT_APP_API_URL}${ApiUrl.USER_CUSTOM_WORKOUT}?userId=${userProfile?._id}`,

        {
          baseURL: `${process.env.REACT_APP_API_URL}`,
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              Constants.accessToken
            )}`,
          },
        }
      );
      setLoader(false);
      // Create a Blob from the data and generate a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `CustomWorkout_${userSingle?.user?.userName}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setLoader(false);
      console.error("Error downloading the Excel file:", error);
    }
  };

  return (
    <div className="container-xxl mb-4">
      <PageHeader
        // pagetitle={userSingle?.user?.userName || Constants.na}
        // pagetitle={userProfile?.userName || Constants.na}
        pagetitle={userProfile?.name || userProfile?.firstName || userProfile?.userName || Constants.notProvided}
        list={location.state?.freqUsersPath || location.state?.dashboardPage || RoutesUrl?.users}
      />
      {/* Personal Details */}
      <CardBlock user={userSingle?.user} />
      <div className="row">
        {/* Goals */}
        <div className="col-md-4 d-flex">
          <div className="card mt-4 border-shadow w-100 card-clr card-red card-user-details">
            <h4 className="grey_bg">{`${Constants.goals}`}</h4>
            <div className="h5 line-b">
              <p className="d-flex align-items-center justfy-bw">
                <div>{`Type : ${userInsights?.latestGoal?.type ? userInsights?.latestGoal?.type : Constants.notProvided}`}</div>
              </p>
              <p className="d-flex align-items-center justfy-bw">
                <div>{`Duration : ${userInsights?.latestGoal?.duration ? userInsights?.latestGoal?.duration + " Weeks" : Constants.notProvided}`}</div>
              </p>
              <p className="d-flex align-items-center justfy-bw">
                <div>

                  {/* {`Start Date :  ${dayjs(
                  userInsights?.latestGoal?.startDate
                ).format(Constants.dateFormat)} at ${dayjs(
                  userInsights?.latestGoal?.startDate
                ).format(Constants.timeFormat)}`} */}

                  Start Date: {
                    userInsights?.latestGoal?.startDate
                      ? `${dayjs(userInsights.latestGoal.startDate).format(Constants.dateFormat)} at ${dayjs(userInsights.latestGoal.startDate).format(Constants.timeFormat)}`
                      : Constants.na
                  }


                </div>
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 d-flex">
          <div className="card mt-4 border-shadow w-100 card-clr card-user-details">
            <h4 className="grey_bg">{Constants.other}</h4>
            <div className="h5 line-b">
              <p className="d-flex align-items-center justfy-bw">
                <div>
                  Avg workouts/week:
                  <AvgWorkoutsCard />


                </div>
              </p>
              <p className="d-flex align-items-center justfy-bw">
                <div>{`Last Active :  ${dayjs(userInsights?.userLastLogin).format(
                  Constants.dateFormat
                )} at ${dayjs(userInsights?.userLastLogin).format(
                  Constants.timeFormat
                )}`}</div>
              </p>
              <p className="d-flex align-items-center justfy-bw">
                <div>

                  {/* {`Custom Workout : ${
                  userSingle?.customWorkouts?.length > 0
                    ? userSingle?.customWorkouts
                        ?.slice(0, 2)
                        ?.map((elt) => elt?.workoutName)
                        .join(", ")
                    : Constants.na
                }`} */}

                  {`Custom Workout : ${userInsights?.customWorkouts > 0
                    ? userInsights?.customWorkouts
                    : Constants.na
                    }`}


                </div>
                {userInsights?.customWorkouts > 0 && (
                  <>
                    {loader ? (
                      <img
                        src={Spinner}
                        alt="spinner"
                        width="30px"
                        height="30px"
                      />
                    ) : (
                      <i
                        className="icofont-download"
                        style={{ color: "black", cursor: "pointer" }}
                        onClick={() => downloadCustomWorkout()}
                      ></i>
                    )}
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-4 d-flex">
          <div className="card mt-4 border-shadow w-100 card-clr card-user-details">
            <h4 className="grey_bg">Badges & Challenges</h4>
            <div className="h5 line-b">
              <p className="d-flex align-items-center justfy-bw">
                <div
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  data-toggle="tooltip"
                  data-placement="top"
                  data-delay={50}
                  title={`Badges : ${userInsights?.badges?.length > 0
                    ? userInsights?.badges?.map(
                      (elt) => elt
                    ).join(", ")
                    : Constants.na
                    }`}

                >


                  {/* {`Badges : ${
                  userSingle?.BadgesEarned?.length > 0
                    ? userSingle?.BadgesEarned?.map(
                        (elt) => elt?.BadgeId?.name
                      ).join(", ")
                    : Constants.na
                }`} */}

                  {`Badges : ${userInsights?.badges?.length > 0
                    ? userInsights?.badges?.map(
                      (elt) => elt
                    ).join(", ")
                    : Constants.na
                    }`}

                  {/* <span class="tooltip-text"> This is a tooltip  </span> */}


                </div>
              </p>
              <p className="d-flex align-items-center justfy-bw">
                <div
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                  data-toggle="tooltip"
                  data-placement="top"
                  data-delay={50}
                  title={`Challenges : ${userInsights?.userchallengesrecord?.length > 0
                    ? userInsights?.userchallengesrecord
                      ?.map((elt) => elt?.name)
                      .join(", ")
                    : Constants.na
                    }`}
                >
                  {/*
                  {`Challenges : ${
                  userSingle?.challengeJoined?.length > 0
                    ? userSingle?.challengeJoined
                        ?.map((elt) => elt?.challengeId?.name)
                        .join(", ")
                    : Constants.na
                }`} */}


                  {`Challenges : ${userInsights?.userchallengesrecord?.length > 0
                    ? userInsights?.userchallengesrecord
                      ?.map((elt) => elt?.name)
                      .join(", ")
                    : Constants.na
                    }`}


                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Analytics />
    </div>
  );
};

export default UserDetail;
